export default __webpack_public_path__ + "static/media/bodycard1.8679479f.png";